var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71455 0.980347C1.04374 0.980347 0.670805 1.75629 1.08985 2.2801L4.62535 6.69948C4.94561 7.0998 5.55448 7.0998 5.87474 6.69948L9.41024 2.2801C9.82929 1.75629 9.45635 0.980347 8.78555 0.980347H1.71455Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonIcon);
export default __webpack_public_path__ + "static/media/arrow-button-icon.444e8c9802f8e10fecb5e3b8ed5a325f.svg";
export { ForwardRef as ReactComponent };